import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ApiOptionItem } from '../../interfaces/api.interface';
import { SampleDet, SampleSuite } from '../../interfaces/option.interface';
import { OptionActions } from '../actions/option.actions';

export const optionsFeatureKey = 'options';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface SampleSuiteState extends EntityState<SampleSuite> {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface SampleDetState extends EntityState<SampleDet> {}

export interface OptionState {
  sampleTypes: string[];
  sampleMatrices: ApiOptionItem[];
  sampleSuite: SampleSuiteState;
  sampleDet: SampleDetState;
  error: unknown;
  pending: boolean;
  sampleSuitePending: boolean;
  sampleDetPending: boolean;
}


const selectSampleSuiteId = (suite: SampleSuite): string => suite.code;
const selectSampleDetId = (det: SampleDet): string => det.id;

const adapterSampleSuite: EntityAdapter<SampleSuite> =
  createEntityAdapter<SampleSuite>({
    selectId: selectSampleSuiteId,
  });

const adapterSampleDet: EntityAdapter<SampleDet> =
  createEntityAdapter<SampleDet>({
    selectId: selectSampleDetId,
  });

const sampleSuiteState: SampleSuiteState = adapterSampleSuite.getInitialState(
  {},
);

const sampleDetState: SampleDetState = adapterSampleDet.getInitialState({});

export const initialState: OptionState = {
  sampleTypes: [],
  sampleMatrices: [],
  sampleSuite: sampleSuiteState,
  sampleDet: sampleDetState,
  error: null,
  pending: false,
  sampleSuitePending: false,
  sampleDetPending: false,
};

export const reducer = createReducer(
  initialState,
  on(OptionActions.loadSampleSuites, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
      sampleSuitePending: true,
    };
  }),
  on(OptionActions.loadSampleSuitesSuccess, (state, { data }) => {
    return {
      ...state,
      sampleSuite: adapterSampleSuite.setAll(data, {
        ...state.sampleSuite,
      }),
      error: null,
      pending: true,
      sampleSuitePending: false,
    };
  }),
  on(OptionActions.loadSampleSuitesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
      sampleSuitePending: false,
    };
  }),
  on(OptionActions.loadSampleDets, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
      sampleDetPending: true,
    };
  }),
  on(OptionActions.loadSampleDetsSuccess, (state, { data }) => {
    return {
      ...state,
      sampleDet: adapterSampleDet.setAll(data, {
        ...state.sampleDet,
      }),
      error: null,
      pending: false,
      sampleDetPending: false,
    };
  }),
  on(OptionActions.loadSampleDetsFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
      sampleDetPending: false,
    };
  }),
  on(OptionActions.loadSampleTypes, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleTypesSuccess, (state, { data }) => {
    return {
      ...state,
      sampleTypes: data,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleTypesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),
  on(OptionActions.loadSampleMatrices, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleMatricesSuccess, (state, { data }) => {
    return {
      ...state,
      sampleMatrices: data,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleMatricesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),
);

export const { selectAll: selectAllSampleSuite } =
  adapterSampleSuite.getSelectors();

export const { selectAll: selectAllSampleDet } =
  adapterSampleDet.getSelectors();
